import { registerGlobalErrorHandlers } from '@/shared/logger';
import { browser } from '@/shared/mocks/browser';

registerGlobalErrorHandlers();

// https://github.com/mswjs/examples/pull/101
if (process.env.NEXT_PUBLIC_MOCK_ENABLED === 'true') {
  void browser.start({
    onUnhandledRequest: 'bypass',
    quiet: true,
  });
}
